export default __webpack_public_path__ + "static/hw_ff_button-df371daae0711c790c191a6c3eccef05.png";